import React, { ReactNode } from 'react';
interface ChatBotTemplateProps {
  children: ReactNode;
  timeStamp: string;
}

const ChatBotTemplate: React.FC<ChatBotTemplateProps> = ({
  children,
  timeStamp,
}) => {
  const clientType = process.env.REACT_APP_CLIENT;

  const renderBrandLogo = () => {
    switch (clientType) {
      case 'salesbot2290ai':
        return (
          <div className="ai2290-brand-bg">
            <div className="ai2290-brand-icon"></div>
          </div>
        );

      case 'salesbottax1099':
        return (
          <div className="aitax1099-brand-bg">
            <div className="aitax1099-brand-icon"></div>
          </div>
        );
    }
    return <></>;
  };

  return (
    <>
      <div className="flex my-8 space-x-3  sm:w-11/12  w-full relative">
        {/* <div className="taxLogo-bg">
          <div className="bg-no-repeat bg-center taxLogo"></div>
        </div> */}
        {renderBrandLogo()}
        {/* <div className=""></div> */}
        {/* <img
          src={taxLogo}
          alt="Chat Bot"
          className="order-first h-10 w-10 rounded-full bg-white"
        /> */}
        <div className="bg-[#FFFFFF] sm:p-4 p-2 rounded-r-lg rounded-bl-lg divide-neutral-900/10 w-full sm:w-10/12">
          {children}
        </div>
        <div className="absolute bottom-[-22px] left-[42px]">
          <span className=" text-gray-500 leading-none text-start text-[12px]">
            {timeStamp}
          </span>
        </div>
      </div>
    </>
  );
};

export default ChatBotTemplate;
